<template>
  <div ref="containerRef" class="w-max">
    <button
      type="button"
      class="bg-background-warning-primary flex w-max items-center rounded-[14px] py-1"
      :class="[
        isKKLocale ? 'flex-row-reverse' : 'flex-row space-x-1',
        isShort ? 'px-2' : 'pl-2.5 pr-2',
      ]"
      :disabled="!isShort"
      @click="toggleTooltip"
    >
      <span
        v-if="isShort"
        class="text-text-static-black text-xs font-medium opacity-80"
      >
        -{{ PERCENTAGE }}%
      </span>
      <span
        v-else
        class="text-text-static-black text-xs font-medium opacity-80"
        :class="isKKLocale ? 'pl-1' : ''"
        >{{
          isFree
            ? $t('products.friends.free')
            : $t('products.friends.discount', { percentage: PERCENTAGE })
        }}</span
      >
      <FriendsIcon v-if="!isShort" />
    </button>
    <div
      v-if="isShort && isTooltipVisible"
      class="bg-background-neutral-quaternary absolute -right-1 top-[calc(100%+9px)] z-20 w-56 rounded-xl px-4 py-2"
    >
      <svg
        width="20"
        height="8"
        class="text-background-neutral-quaternary absolute -top-2 right-4"
        viewBox="0 0 20 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 -8.74228e-07C7 -1.1365e-06 4.0001 8 -6.99382e-07 8L20 8C16.0251 8 13 -6.11959e-07 10 -8.74228e-07Z"
          fill="currentColor"
        />
      </svg>
      <p class="text-text-neutral-white text-sm">
        {{ tooltipText }}
      </p>
    </div>
  </div>
</template>

<script setup>
  import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
  import { appLocale } from 'shared';
  import { useI18n } from 'vue-i18n';

  import FriendsIcon from './assets/friends-icon.svg?component';

  const PERCENTAGE = 10;

  const props = defineProps({
    isFree: {
      type: Boolean,
      default: false,
    },
    isShort: {
      type: Boolean,
      default: false,
    },
    isBaggage: {
      type: Boolean,
      default: false,
    },
  });

  const { t } = useI18n();
  const containerRef = ref(null);
  const isTooltipVisible = ref(false);

  const tooltipText = computed(() =>
    props.isBaggage
      ? t('products.friends.baggageDiscount')
      : t('products.friends.seatMapDiscount'),
  );

  const toggleTooltip = event => {
    if (!props.isShort) {
      return;
    }
    event.stopPropagation();
    isTooltipVisible.value = !isTooltipVisible.value;
  };

  const handleDocumentClick = event => {
    const container = containerRef.value;
    if (!(container instanceof HTMLElement)) {
      return;
    }
    if (!container.contains(event.target)) {
      isTooltipVisible.value = false;
    }
  };

  onMounted(() => {
    document.addEventListener('click', handleDocumentClick);
  });

  onBeforeUnmount(() => {
    document.removeEventListener('click', handleDocumentClick);
  });

  const isKKLocale =
    appLocale.lib.getAppLocale() === appLocale.config.locales.KK;
</script>
